// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__2HYeV","point-table":"styles-m__point-table__2F_5z","inner-table":"styles-m__inner-table__3R_WZ"};